import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import OrderCsvUploadModal from '@/components/container/modal/csv/OrderCsvUploadModal'

export interface OrderCsvUploadModalState {
  siteId: number
  onClose: () => void
}

const defaultValue: OrderCsvUploadModalState = {
  siteId: 0,
  onClose: () => {}
}

export const OrderCsvUploadModalContext = createModalContext<OrderCsvUploadModalState>(defaultValue)

const OrderCsvUploadModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<OrderCsvUploadModalState>(defaultValue)
  return (
    <OrderCsvUploadModalContext.Provider value={state}>
      {children}
      <OrderCsvUploadModal />
    </OrderCsvUploadModalContext.Provider>
  )
}

export default OrderCsvUploadModalProvider
